import React from 'react';
import { Row, Col, Heading } from 'seduo-ui';
import RoundedImageExample from '../examples/RoundedImage';
const Example = () => (<Row className="testimonial">
        <Col xs={12} md="auto" className="testimonial__image-column">
            <div className="testimonial__image">
                <RoundedImageExample />
            </div>
        </Col>
        <Col xs={12} md>
            <Heading level={4} className="testimonial__title">
                Martin Basl, Livesport, s.r.o., Business Development Manager
            </Heading>
            <p className="testimonial__subtitle">
                Zvýšili jsme soft-skills našich zaměstnanců, což jsme dlouho postrádali.
            </p>
            <p className="testimonial__text">
                "Osvědčilo se nám nabídnout kolegům co nejvíce možností ke vzdělávání, aby si sami vybrali, co je
                zajímá. Seduo do naší firmy přineslo kurzy z oblasti soft-skills, což jsme do té doby neměli. I díky
                tomu byl zájem o kurzy na Seduo velký. Celkově bereme vzdělávání jako důležitý a oblíbený zaměstnanecký
                benefit."
            </p>
        </Col>
    </Row>);
export default Example;
